import Vue from 'vue'
import App from './App.vue'
import store from './store'
import VScaleScreen from 'v-scale-screen'
import dataV from '@jiaminghi/data-view'
import * as echarts from 'echarts'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "../src/style/base.less"
import highcharts from 'highcharts'
import highcharts3d from 'highcharts/highcharts-3d'
highcharts3d(highcharts)

Vue.use(dataV)
Vue.use(VScaleScreen)
Vue.use(ElementUI);

Vue.prototype.$echarts = echarts;


Vue.config.productionTip = false

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')